import { GenericListByConfig } from './GenericList';
import { ChainVerificationBadge } from '../organisms';

/**
 * AuditLog — /v2/audit-logs
 *
 * The raw append-only audit ledger, with a chain-verification strip above it so
 * the ledger's integrity is rendered on the surface, not just asserted. The
 * table itself reuses the schema-driven GenericListByConfig (read-only:
 * audit_logs is append-only).
 *
 * Domain 02.3 — Data Integrity & Audit.
 */
export function AuditLog() {
  return (
    <>
      <ChainVerificationBadge />
      <GenericListByConfig
        table="audit_logs"
        title="Audit Log"
        pageSize={50}
        disableCreate
        createCaption="Append-only system log"
      />
    </>
  );
}
